<template>
  <v-container>
    <v-row align="center">
      <v-col md="5" offset-md="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar justify-center font-weight-bold"
            >Asignación de arma a personal</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular
                    :value="activeStep * 25"
                    size="96"
                    width="12"
                    color="secondary"
                    rotate="-90"
                  ></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption">
                    PASO {{ activeStep }}
                    <div v-if="activeStep == FORM_STEPS.OFICIO" class="d-inline">(Opcional)</div>
                  </div>
                  <div class="text-subtitle-1 font-weight-bold">{{ activeStepTitle }}</div>
                  <a
                    class="text-decoration-none"
                    v-show="activeStep !== FORM_STEPS.BUSQUEDA_PERSONAL"
                    @click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <transition-group name="fade" mode="out-in">
                  <v-col md="12" v-if="activeStep === FORM_STEPS.BUSQUEDA_PERSONAL" key="1">
                    <v-row>
                      <v-col cols="8">
                        <BaseInput
                          v-model="busquedaPersonal.CUIP"
                          label="Buscar personal por CUIP"
                          rounded
                          filled
                          background-color="transparent"
                          color="secondary"
                          class="search-input ui-form-field"
                          :disabled="loadingBusqueda"
                        />
                      </v-col>
                      <v-col cols="4">
                        <TextButton
                          block
                          color="secondary"
                          class="ui-module-btn-solid"
                          @click="triggerSearchPersonal()"
                          :disabled="loadingBusqueda || loading"
                          :loading="loadingBusqueda"
                        >
                          Buscar <v-icon class="ml-2">mdi-magnify</v-icon>
                        </TextButton>
                      </v-col>
                      <v-col cols="12">
                        <PersonalList
                          :personal="personal"
                          @select="(personal) => setPersonalArma(personal.idPersonal, personal.portacionArma)"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="12" v-if="activeStep === FORM_STEPS.FECHA_ASIGNACION" key="2">
                    <v-date-picker
                      v-model="armaPersonal.fechaAsignado"
                      locale="es"
                      color="secondary"
                      no-title
                      full-width
                      :max="getMaxDay"
                    ></v-date-picker>
                  </v-col>
                  <v-col md="12" v-if="activeStep === FORM_STEPS.ASIGNACION_ARMA" key="3">
                    <v-row>
                      <v-col v-if="armasPersonal.length > 0" cols="12">
                        <div class="text-subtitle-1">Armas asignadas actualmente</div>
                        <ArmasPersonalList :armasPersonal="armasPersonal" />
                      </v-col>
                      <v-col cols="6">
                        <BaseSelect
                          class="ui-form-field"
                          v-model="tipoArma"
                          v-on:change="selectedWeapon = null"
                          :items="filteredTipoArma"
                          item-value="id"
                          item-text="title"
                        >
                          <template v-slot:label>Tipo de arma <span class="red--text">*</span> </template>
                        </BaseSelect>
                      </v-col>
                      <v-col cols="6">
                        <BaseSelect
                          class="ui-form-field"
                          :items="tipoAsignacion"
                          item-value="id"
                          item-text="title"
                          v-model="armaPersonal.fk_idTipoAsignacion"
                        >
                          <template v-slot:label>Tipo de asignación <span class="red--text">*</span> </template>
                        </BaseSelect>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          class="ui-form-field"
                          v-model="armaPersonal.fk_idArma"
                          v-on:change="triggerFetchCargadoresByCalibre()"
                          filled
                          rounded
                          dense
                          background-color="transparent"
                          color="secondary"
                          :items="filteredWeaponsByType"
                          item-value="idArma"
                          item-text="CatModelo.modelo"
                          :disabled="filteredWeaponsByType.length == 0"
                          :filter="filterArma"
                          no-data-text="No se encontraron armas"
                          hint="Puedes escribir para filtrar por matrícula, modelo, serie o clase"
                          persistent-hint
                        >
                          <template v-slot:label>Arma <span class="red--text">*</span> </template>
                          <template v-slot:item="{ item, on, attrs }">
                            <v-list-item v-on="on" v-bind="attrs">
                              <v-list-item-content>
                                <v-list-item-subtitle class="text-caption"
                                  >Matrícula: {{ item.matricula }}</v-list-item-subtitle
                                >
                                <v-list-item-title class="text-subtitle-2 font-weight-black"
                                  >Modelo: {{ item.CatModelo.modelo }}</v-list-item-title
                                >
                                <v-list-item-subtitle class="text-caption"
                                  >Serie: {{ item.serie }}</v-list-item-subtitle
                                >
                                <v-list-item-subtitle class="text-caption"
                                  >Clase: {{ item.CatClase.title }}</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <BaseInput
                          class="ui-form-field"
                          label="Cantidad de municiones"
                          type="number"
                          v-model.number="municionesArma.cantidad"
                          autocomplete="off"
                          min="0"
                          :max="municionesDisponibles"
                          :hint="loadingMunicionesDisponibles ? 'Obteniendo cantidad de municiones disponibles...' : (armaPersonal.fk_idArma ? `Disponibles: ${municionesDisponibles}` : '')"
                          persistent-hint
                          :loading="loadingMunicionesDisponibles"
                          :disabled="!armaPersonal.fk_idArma || loadingMunicionesDisponibles"
                          :rules="armaPersonal.fk_idArma ? [v => v <= municionesDisponibles || `Máximo ${municionesDisponibles} municiones disponibles`] : []"
                        ></BaseInput>
                        <BaseTextArea
                          class="ui-form-textarea"
                          :label="labelComentariosArma"
                          v-model="armaPersonal.comentario"
                          rows="4"
                          dense
                          no-resize
                        ></BaseTextArea>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="12" v-if="activeStep === FORM_STEPS.OFICIO" key="4">
                    <v-row>
                      <v-col cols="12">
                        <BaseInput
                          class="ui-form-field"
                          label="Número de oficio de resguardo"
                          v-model="cargadorPersonal.oficio"
                        ></BaseInput>
                      </v-col>
                      <v-col cols="12">
                        <BaseTextArea
                          class="ui-form-textarea"
                          label="Comentarios"
                          v-model="cargadorPersonal.comentario"
                          rows="4"
                          dense
                          no-resize
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </transition-group>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col md="12" xl="6" offset-xl="3" v-if="activeStep > FORM_STEPS.BUSQUEDA_PERSONAL">
                  <v-btn
                    block
                    color="secondary"
                    class="ui-module-btn-solid"
                    @click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.card-flat {
  box-shadow: none !important;
  transition: 0.3s;
}
</style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import TextButton from '../../components/base/TextButton.vue'
import BaseInput from '../../components/base/BaseInput.vue'
import BaseSelect from '../../components/base/BaseSelect.vue'
import BaseTextArea from '../../components/base/BaseTextArea.vue'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'
import PersonalList from './asignacion-arma/PersonalList.vue'
import ArmasPersonalList from './asignacion-arma/ArmasPersonalList.vue'

const FORM_STEPS = {
  BUSQUEDA_PERSONAL: 1,
  FECHA_ASIGNACION: 2,
  ASIGNACION_ARMA: 3,
  OFICIO: 4,
}

export default {
  components: {
    TextButton,
    BaseInput,
    BaseSelect,
    BaseTextArea,
    PersonalList,
    ArmasPersonalList,
  },

  async mounted() {
    await this.fetchTipoAsignacion()
    if (this.weaponStatus.length === 0) {
      await this.fetchEstatusArma()
    }
    if (this.weaponTypes.length === 0) {
      await this.fetchTiposArma()
    }
  },

  beforeRouteLeave(to, from, next) {
    this.RESET_BUSQUEDA_PERSONAL()
    next()
  },

  data() {
    return {
      FORM_STEPS,
      activeStep: FORM_STEPS.BUSQUEDA_PERSONAL,
      loading: false,
      cuipForm: false,
      cuip: null,
      successfulCuipSearch: null,
      selectedPersonal: null,
      tipoArma: null,

      armaPersonal: {
        fk_idPersonal: null,
        fk_idArma: null,
        fk_idTipoAsignacion: null,
        fechaAsignado: null,
        comentario: '',
      },

      municionesArma: {
        fk_idArma: 0,
        fk_idCalibre: 0,
        cantidad: 0,
        fechaAsignado: null,
      },

      cargadorPersonal: {
        fk_idPersonal: null,
        fk_idCargador: 0,
        fechaAsignado: null,
        oficio: '',
        comentario: '',
      },

      cuipRules: [(v) => !!v || 'Por favor, ingrese el CUIP.'],

      busquedaPersonal: {
        nombre: '',
        segundoNombre: '',
        apaterno: '',
        amaterno: '',
        curp: '',
        CUIP: '',
      },

      loadingBusqueda: false,
      loadingMunicionesDisponibles: false,
      susceptibleTercerArma: false,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
    }),

    ...mapGetters('arma', {
      weapons: 'getArmas',
    }),

    ...mapGetters('tipoArma', {
      weaponTypes: 'getTipoArmas',
    }),

    ...mapGetters('estatusArma', {
      weaponStatus: 'getEstatusArma',
    }),

    ...mapGetters('tipoAsignacionArma', {
      tipoAsignacion: 'getTipoAsignacion',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
      idArmaPersonal: 'getIdArmaPersonal',
    }),

    ...mapGetters('cargadores', {
      cargadores: 'getCargadores',
    }),

    ...mapGetters('movimientoMunicion', {
      movimientoMunicionDisponibles: 'getMovimientoMunicionDisponibles',
    }),

    getMaxDay: function () {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },

    idsEstatusPermitidos: function () {
      const ESTATUS_PERMITIDOS = ['ACTIVO', 'ASIGNADO']
      return this.weaponStatus
        .filter((estatus) => ESTATUS_PERMITIDOS.includes((estatus.title || '').trim().toUpperCase()))
        .map((estatus) => estatus.id)
    },

    filteredArmas: function () {
      return this.weapons.filter((arma) => {
        return this.idsEstatusPermitidos.includes(arma.fk_idEstatus)
      })
    },

    filteredTipoArma: function () {
      if (this.susceptibleTercerArma) {
        return this.weaponTypes
      }

      if (this.armasPersonal.some((arma) => arma.Arma.CatClase.fk_idTipo == 1)) {
        return this.weaponTypes.filter((tipoArma) => {
          return tipoArma.id == 2
        })
      } else if (this.armasPersonal.some((arma) => arma.Arma.CatClase.fk_idTipo == 2)) {
        return this.weaponTypes.filter((tipoArma) => {
          return tipoArma.id == 1
        })
      } else {
        return this.weaponTypes
      }
    },

    activeStepTitle: function () {
      switch (this.activeStep) {
        case 1:
          return 'Elegir personal'
        case 2:
          return 'Fecha de asignación'
        case 3:
          return 'Arma, municiones y cargadores'
        case 4:
          return 'Oficio'
      }
    },

    validActiveStep: function () {
      switch (this.activeStep) {
        case 1:
          // if (this.cuipForm) {
          //     return true
          // } else {
          //     return false
          // }
          return true
        case 2:
          // if (this.weaponAssignmentEntryDate != '') {
          //     return true
          // } else {
          //     return false
          // }
          return true
        case 3:
          return (
            !!this.armaPersonal.fk_idArma &&
            this.municionesArma.cantidad >= 0 &&
            this.municionesArma.cantidad <= this.municionesDisponibles
          )
        case 4:
          // if (this.weaponAssignmentOfficeFile) {
          //     return true
          // } else {
          //     return false
          // }
          return true
      }
    },

    activeStepButtonLabel: function () {
      if (this.activeStep < 4) {
        return 'Siguiente paso'
      } else {
        return 'Registrar arma'
      }
    },

    filteredWeaponsByType: function () {
      return this.filteredArmas.filter((weapon) => {
        return weapon.CatClase?.fk_idTipo == this.tipoArma
      })
    },

    municionesDisponibles: function () {
      if (Array.isArray(this.movimientoMunicionDisponibles) && this.movimientoMunicionDisponibles.length > 0) {
        return this.movimientoMunicionDisponibles[0].disponibles ?? 0
      }
      return 0
    },

    labelComentariosArma: function () {
      const tipo = this.weaponTypes.find((t) => t.id == this.tipoArma)
      if (!tipo) return 'Accesorios (Opcional)'
      const titulo = (tipo.title || '').toLowerCase()
      if (titulo.includes('corta')) return 'Accesorios arma corta (Opcional)'
      if (titulo.includes('larga')) return 'Accesorios arma larga (Opcional)'
      return 'Accesorios (Opcional)'
    },
  },

  methods: {
    ...mapActions('armaPersonal', ['saveArmaPersonal', 'fetchArmasPersonal']),
    ...mapActions('municionArma', ['saveMunicionArma']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('tipoArma', ['fetchTiposArma']),
    ...mapActions('cargadores', ['fetchCargadores']),
    ...mapActions('movimientoMunicion', ['fetchMovimientoMunicionDisponibles']),
    ...mapActions('cargadorPersonal', ['saveCargadorPersonal']),
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),
    ...mapActions('notificaciones', ['createNotification']),

    activeStepButtonHandler: async function () {
      if (this.activeStep === FORM_STEPS.BUSQUEDA_PERSONAL) {
        this.handleFetchArmasPersonal()
      } else if (this.activeStep > FORM_STEPS.BUSQUEDA_PERSONAL && this.activeStep < FORM_STEPS.OFICIO) {
        this.activeStep++
      } else {
        await this.triggerAsignacionArma()
      }
    },

    async triggerAsignacionArma() {
      try {
        this.loading = true

        this.armaPersonal.fechaAsignado = moment(this.armaPersonal.fechaAsignado).format(this.API_DATE_FORMAT)
        this.cargadorPersonal.fechaAsignado = this.armaPersonal.fechaAsignado
        this.municionesArma.fechaAsignado = this.armaPersonal.fechaAsignado
        this.municionesArma.fk_idCalibre = this.filteredArmas.find(
          (arma) => arma.idArma == this.armaPersonal.fk_idArma
        ).fk_idCalibre
        this.cargadorPersonal.fk_idPersonal = this.armaPersonal.fk_idPersonal

        await this.saveArmaPersonal(this.armaPersonal)
        await this.sendNotificacion()
        this.municionesArma.fk_idArma = this.armaPersonal.fk_idArma
        await this.saveMunicionArma(this.municionesArma)
        this.SET_SNACKBAR_MESSAGE('Arma asignada a personal correctamente.')
        this.RESET_BUSQUEDA_PERSONAL()
        this.$router.push('/armeria/personal_armamento')
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al asignar el arma al personal.')
      } finally {
        this.loading = false
      }
    },

    async sendNotificacion() {
      const armaAsignada = this.filteredArmas.find((arma) => arma.idArma == this.armaPersonal.fk_idArma)

      const notification = new NotificationFactory(Notificacion).createNotification(
        NOTIFICATION_TYPES.REGISTRO_MOVIMIENTO_ARMA,
        {
          responsable: Number(localStorage.getItem('idPersonal')),
          afectado: this.armaPersonal.fk_idPersonal,
          marcaArma: armaAsignada.CatModelo?.CatMarca?.title,
          modeloArma: armaAsignada.CatModelo?.modelo,
          matricula: armaAsignada?.matricula,
          noEconomico: armaAsignada?.noEconomico,
          nombrePersonal: this.getFullName(this.personal.find((p) => p.idPersonal == this.armaPersonal.fk_idPersonal)),
        }
      )

      await this.createNotification(notification)
    },

    async triggerFetchCargadoresByCalibre() {
      var arma = this.filteredArmas.filter((arma) => {
        return arma.idArma == this.armaPersonal.fk_idArma
      })
      const idCalibre = arma[0].fk_idCalibre
      this.loadingMunicionesDisponibles = true
      this.municionesArma.cantidad = 0
      try {
        await Promise.all([
          this.fetchCargadores(idCalibre),
          this.fetchMovimientoMunicionDisponibles(idCalibre),
        ])
      } finally {
        this.loadingMunicionesDisponibles = false
      }
    },

    buscaPersonal() {
      return new Promise(async () => {
        setTimeout(await this.searchPersonal(this.busquedaPersonal), 200)
        this.loadingBusqueda = false
      })
    },

    triggerSearchPersonal() {
      this.loadingBusqueda = true
      if (this.busquedaPersonal.CUIP !== '') {
        this.buscaPersonal()
      } else {
        this.loadingBusqueda = false
        this.RESET_BUSQUEDA_PERSONAL()
      }
    },

    setPersonalArma(id_personal, susceptibleTercerArma) {
      this.susceptibleTercerArma = susceptibleTercerArma
      this.armaPersonal.fk_idPersonal = id_personal
      this.tipoArma = null
      this.activeStepButtonHandler()
    },

    filterArma(item, queryText) {
      const query = queryText.toLowerCase()
      return (
        item.matricula?.toLowerCase().includes(query) ||
        item.CatModelo?.modelo?.toLowerCase().includes(query) ||
        item.serie?.toLowerCase().includes(query) ||
        item.CatClase?.title?.toLowerCase().includes(query)
      )
    },

    async handleFetchArmasPersonal() {
      const CANTIDAD_ARMAS_PERMITIDAS = this.susceptibleTercerArma ? 3 : 2

      try {
        this.loading = true
        await this.fetchArmasPersonal(this.armaPersonal.fk_idPersonal)

        if (this.armasPersonal.length < CANTIDAD_ARMAS_PERMITIDAS) {
          this.activeStep++
        } else {
          this.SET_SNACKBAR_MESSAGE(
            `El elemento seleccionado ya cuenta con ${CANTIDAD_ARMAS_PERMITIDAS} armas asignadas.`
          )
        }
      } catch {
        this.SET_SNACKBAR_MESSAGE(`No fue posible obtener las armas asignadas al elemento.`)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* Progreso circular */
::v-deep .v-progress-circular {
  transition: all 0.3s ease;
}

::v-deep .v-progress-circular__overlay {
  stroke: #6c5ce7 !important;
  filter: drop-shadow(0 0 8px rgba(108, 92, 231, 0.5));
}

/* Date picker */
::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-header {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-btn--active {
  background: #6c5ce7 !important;
  color: #ffffff !important;
}

::v-deep .v-date-picker-table__current {
  border-color: #6c5ce7 !important;
}

/* Inputs del formulario */
::v-deep .ui-form-field .v-input__slot,
::v-deep .search-input .v-input__slot,
::v-deep .ui-form-textarea .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot {
  min-height: 48px !important;
}

::v-deep .ui-form-field .v-input__slot:hover,
::v-deep .search-input .v-input__slot:hover,
::v-deep .ui-form-textarea .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control,
::v-deep .search-input .v-input__control,
::v-deep .ui-form-textarea .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control,
::v-deep .search-input.v-input--is-focused .v-input__control,
::v-deep .ui-form-textarea.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .search-input input,
::v-deep .ui-form-textarea textarea,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .search-input .mdi-magnify {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .search-input .v-label,
::v-deep .ui-form-textarea .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .search-input.v-input--is-focused .v-label,
::v-deep .ui-form-textarea.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Lista de items */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  transition: all 0.3s ease;
  background: rgba(18, 18, 18, 0.3) !important;
  border: 1px solid rgba(108, 92, 231, 0.1);
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.2) !important;
  border-color: rgba(108, 92, 231, 0.3);
  transform: translateX(4px);
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: #e0e0e0 !important;
}

/* Enlaces */
a {
  color: #6c5ce7 !important;
  transition: all 0.3s ease;
}

a:hover {
  color: #a29bfe !important;
  text-decoration: underline !important;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

.text-caption,
.text-subtitle-1,
.text-subtitle-2 {
  color: #e0e0e0 !important;
}

/* Transiciones */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Menu del select */
::v-deep .v-menu__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

/* Asterisco rojo para campos requeridos */
.red--text {
  color: #ff5252 !important;
}

/* ==================== DATE PICKER MEJORADO ==================== */
::v-deep .v-date-picker-header {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-date-picker-header .v-btn {
  color: #a29bfe !important;
}

::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-table .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table .v-btn:hover {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-date-picker-table .v-btn--active {
  background: linear-gradient(135deg, #6c5ce7 0%, #a29bfe 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(108, 92, 231, 0.4);
}

::v-deep .v-date-picker-table__current {
  border-color: #6c5ce7 !important;
}

/* ==================== TOOLTIPS ==================== */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* ==================== SCROLLBAR ==================== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
